import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { DocumentPage } from "@/components/documents/document-page";

type DocumentSearch = { edit?: true };

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/documents/$documentId")({
  // `edit` opens the document being written: a new one is. Whatever the URL
  // says, this returns a page that can be drawn: it never throws.
  validateSearch: (search: Record<string, unknown>): DocumentSearch =>
    search.edit === true || search.edit === "true" ? { edit: true } : {},
  component: DocumentRoute,
});

function DocumentRoute() {
  const { documentId } = Route.useParams();
  const { edit } = Route.useSearch();
  const navigate = Route.useNavigate();
  const started = useCallback(() => void navigate({ search: {}, replace: true }), [navigate]);
  // Keyed by document: a draft is one document's.
  return (
    <DocumentPage
      key={documentId}
      documentId={documentId}
      startEditing={edit === true}
      onStarted={started}
    />
  );
}
